import { render, staticRenderFns } from "./add-new-message.vue?vue&type=template&id=44bb0eb2&scoped=true&"
import script from "./add-new-message.vue?vue&type=script&lang=js&"
export * from "./add-new-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb0eb2",
  null
  
)

export default component.exports